import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M19.2 16.809c-3.976 3.976-10.424 3.976-14.4 0l-1.8-9 5.4 1.8 3.6-5.4 3.6 5.4 5.4-1.8z"
    />
  </svg>
);
export const SpecializationIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
